/**
 * Печатает ли человек в этот момент. Общий гард глобальных хоткеев (DEV-2039):
 * у палитры и фильтр-бара он обязан быть одинаковым, иначе «/» в одном месте
 * печатает слэш, а в другом — крадёт фокус у редактора.
 */
export const isTyping = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false

  if (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) return true

  // Не `isContentEditable`: в редакторе событие приходит от той ноды, где
  // стоит курсор, а редактируемый корень — её предок.
  return Boolean(target.closest('[contenteditable="true"]'))
}
